const initialDraftListState = {
  currentDraftId: "",
  drafts: [],
  selectedDrafts: []
};

export default initialDraftListState;
